import React from "react";
import ShareSectionDrawer from "./ShareSectionDrawer";
import CourseCertificateInfographic from "./CourseCertificateInfographic";
import "./LessonNotes.css";

/**
 * Drawer plus the off-screen certificate that gets captured for the share image.
 * Takes the object returned by useCertificateShare.
 */
export default function CertificateShareSurfaces({ share, isDarkMode }) {
  const { shareJob, drawerExpanded, certificateRef, closeDrawer, retryShare } =
    share;

  return (
    <>
      <ShareSectionDrawer
        job={shareJob}
        expanded={drawerExpanded}
        isDarkMode={isDarkMode}
        onClose={closeDrawer}
        onRetry={retryShare}
      />
      {shareJob?.status === "generating" && shareJob.certificate && (
        <div className="share-infographic-capture" aria-hidden="true">
          <CourseCertificateInfographic
            ref={certificateRef}
            recipientName={shareJob.certificate.recipientName}
            courseTitle={shareJob.certificate.courseTitle}
            courseCover={shareJob.certificate.courseCover}
            givenOn={shareJob.certificate.givenOn}
          />
        </div>
      )}
    </>
  );
}
